/**
 * 工单年度评分统计组件
 */

import { useEffect, useState } from 'react';
import { Row, Col, Select, message, InputNumber } from 'antd';
import { Chart } from '@antv/g2';
import $ from 'jquery';
import {
    isGTscreenWidth,
    UjoinParams,
    AddRequestHeaders,
} from '../../incs/FunHelper.js';
import CNF from '../../incs/Config.js';

var date = new Date();
const CURRENTYEAR = date.getFullYear();

const WOWDCR = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [isRefresh, setIsRefresh] = useState(true);
    const [data, setData] = useState([]);

    const [projectUlid, setProjectUlid] = useState('');
    const [projectDDList, setProjectDDList] = useState('');
    const [year, setYear] = useState(CURRENTYEAR);

    useEffect(() => {
        if (props.data) {
            setData(props.data);
        } else {
            if (isRefresh) {
                // 获取数据
                const params = {
                    'start_date': year + '-01-01',
                    'end_date': year + '-12-31',
                    'project_ulid': projectUlid,
                }
                $.ajax({
                    url: `${CNF.api}reports/wo/wdcr${UjoinParams(params)}`,
                    headers: AddRequestHeaders(),
                    crossDomain: true,
                    type: 'GET',
                    dataType: 'JSON', success: function (data) {
                        if (data.res === 0) {
                            setData(data.dat);
                            setIsRefresh(false);
                        } else {
                            messageApi.error(data.msg, CNF.messageDuration);
                        }
                    }
                })
            }
        }
    }, [props, isRefresh, messageApi, year, projectUlid]);

    useEffect(() => {
        if (!props.data && projectDDList.length === 0) {
            const params = {
                'rss': 'list',
                'page_size': 65535,
                'current_index': 1
            };
            $.ajax({
                url: `${CNF.api}project/bases${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        setProjectDDList(data.dat);
                    }
                }
            })
        }

    }, [props, projectDDList.length]);

    useEffect(() => {
        const chart = new Chart({
            container: 'antv-g2-id',
            autoFit: true,
        });

        chart.title({
            title: '工单年度评分统计',
            subtitle: '展示年度内工单评分分类统计数量。',
        });

        chart.data(data);

        chart
            .interval()
            .encode('x', 'type')
            .encode('y', 'count')
            .encode('color', 'type')
            .scale('color', {
                range: CNF.swatches[CNF.currentSwatche],
            })
            .axis('x', { title: '日期', })
            .axis('y', {
                title: '数量',
                labelFormatter: (d) => `${d > 10000 ? (d / 10000).toFixed(CNF.DPL) : d}`
            })
            .animate('enter', {
                type: 'scaleInY',
                duration: CNF.animateDuration,
            },)
            .tooltip({
                items: [
                    (d) => {
                        return { channel: 'y', value: `${d.count}个`, }
                    },
                ],
            })
            .style('minWidth', 40)
            .style('maxWidth', 60);
        chart.render();

        return () => {
            chart.destroy();
        }
    }, [props.collapsed, data]);

    return <>
        {contextHolder}
        <Row style={{ margin: '15px 0 0 15px' }}>
            <Col span={isGTscreenWidth ? 5 : 6}>
                <Select
                    showSearch
                    allowClear
                    placeholder='请选择项目'
                    style={{ width: '100%' }}
                    onChange={(value) => { setProjectUlid(value === undefined ? '' : value); setIsRefresh(true); }}
                    value={projectUlid ? projectUlid : undefined}
                    filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                    options={projectDDList && projectDDList.map((item, index) => ({
                        key: index,
                        value: item.key,
                        label: item.name,
                    }))}
                />
            </Col>
            <Col span={2} style={{ marginLeft: CNF.searchMarginLeft, }}>
                <InputNumber
                    placeholder='选择年份'
                    style={{ width: '100%' }}
                    min={2023}
                    max={2043}
                    suffix='年'
                    value={year ? year : null}
                    onChange={(value) => { setYear(value); setIsRefresh(true); }}
                />
            </Col>
        </Row>
        <div id='antv-g2-id'></div>
    </>

}

export default WOWDCR;